import { ca } from '@cian/analytics';

import { TGallerySiteType } from '../../types/analytics';

export interface ITrackOpenFullGallery {
  newbuildingId?: number;
  siteType: TGallerySiteType;
}

export function trackOpenFullGallery({ newbuildingId, siteType }: ITrackOpenFullGallery) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'open_fullscreen_gallery',
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      extra: {
        seller_type: 'builders',
      },
      siteType: siteType,
      pageType: 'ListingCompareJK',
    },
  });
}
